// Libs
import classNames from 'classnames/bind';
// Components, Layouts, Pages
import { Box } from '@mui/material';
// Others
// Styles, images, icons
import styles from './CommunicationPhoneCalls.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const CommunicationPhoneCalls = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return <Box component={'div'} id='communicationPhoneCallsComponent' className={cx('container')}></Box>;
};

export default CommunicationPhoneCalls;
